<template>
    <div style="display: flex; flex-direction: column;">
        <MercenaryHeader :title="reviewPageType" :back-title="'뒤로가기'" :close-action="() => { $GlobalStore.closeLastModal() }"></MercenaryHeader>
        <div style="flex: 1; overflow-y: scroll; margin-top: 20px; padding: 0 20px;">
            <div v-for="each, i in reviewList" :key="i" style="padding: 0 12px; border-radius: 24px; background: #f5f5f5; padding: 24px; margin-bottom: 24px;">
                <div style="border-bottom: 1px solid #ebebeb; padding-bottom: 16px;">
                    <ProfileImage :imagePath="each.image_path" style="width: 60px;"></ProfileImage>
                    <div style="margin-top: 8px; font-weight: 700; font-size: 14px; line-height: 24px;">{{ each.nic_name }} <span style="color: var(--color-main); font-weight: 700;">{{ each.position }}</span></div>
                </div>
                <div style="padding: 16px 0; border-bottom: 1px solid #ebebeb;">
                    <div class="title">후기</div>
                    <div style="font-weight: 500; line-height: 24px; text-align: left;">{{ each.contents }}</div>
                </div>
                <div style="padding: 16px 0; border-bottom: 1px solid #ebebeb;">
                    <div class="title">좋은점</div>
                    <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ each.additional_info1 }}</div>
                </div>
                <div style="padding: 16px 0; padding-bottom: 0;">
                    <div class="title">다음 참여 의향</div>
                    <div style="font-weight: 500; font-size: 14px; line-height: 24px;">{{ each.additional_info2 }}</div>
                </div>
            </div>
            <div v-if="reviewPageType === REVIEW_PAGE_TYPE.SENT && isShowPopup" style="margin-top: 32px;">
                <div style="border-radius: 12px; background-color: #f5f5f5; padding: 12px; display: flex; align-items: center; gap: 12px; position: relative;">
                    <div @click="hidePopup" style="position: absolute; right: 12px; top: 6px; width: 20px; height: 20px; text-align: center;">
                        <img style="width: 7px;" :src="require('@/assets/img/poll_hide_btn.png')" alt="">
                    </div>
                    <div>
                        <img style="width: 50px;" :src="require('@/assets/img/share_friend.png')" alt="">
                    </div>
                    <div>
                        <div style="font-weight: 700; font-size: 14px; line-height: 20px; margin-bottom: 2px;">이 트레이닝을 친구와 함께 해보세요!</div>
                        <div style="font-weight: 400; font-size: 12px; line-height: 20px; margin-bottom: 2px;">트레이닝이 마음에 들었다면 친구나 지인에게도 추천해서 같이 트레이닝 받아보세요. 더 재밌어질 거예요.</div>
                        <div @click="share" style="font-weight: 500; font-size: 12px; line-height: 20px; color: #4b8aff;">공유하여 친구랑 같이하기</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MercenaryHeader from '@/components/common/MercenaryHeader'
import ProfileImage from '@/components/common/ProfileImage'
import { REVIEW_PAGE_TYPE } from '@/Constants'

export default {
    name: "ReviewHistory",
    components: { MercenaryHeader, ProfileImage },
    props: {
        join_schedule_idx: {
            type: [Number, String],
            default: () => {}
        },
        reviewPageType: {
            type: String,
            default: ''
        },
        member_idx : {
            type : [Number, String],
            default : -1
        }
    },
    data() {
        return {
            reviewList: [],
            REVIEW_PAGE_TYPE: REVIEW_PAGE_TYPE,
            isShowPopup: true
        }
    },
    methods: {
        share() {
            const device = this.$cookies.get('device');

            let domain = '';
            if (process.env.NODE_ENV === 'development') {
                domain = 'http://192.168.0.203:8080';
            } else {
                if (process.env.VUE_APP_IS_TEST_SERVER !== undefined) {
                    domain = 'https://obyungear-user-test.ubiplus.co.kr';
                } else {
                    domain = 'https://app.soccerhow.com';
                }
            }
            
            let url = `${domain}/team?target=` + this.reviewList[0].idx;
            console.log(url);
            const message = '트레이닝';
            
            if (device === 'android') {
                const text = (message === "" ? "" : message + "\n") + url;
                window.Android.shareUrl(text);
            } else if (device === 'ios') {
                /*eslint-disable no-undef */
                webkit.messageHandlers.ios.postMessage({ cmd: 'shareUrl', text: message, url: url });
            } else {
                navigator.share({
                    title: message,
                    url: url
                }).then(() => {
                    console.log('Thanks for sharing!');
                }).catch(() => {
                    console.log('share error');
                });
            }
        },
        async getSentReviewHistory() {
            const parameters = {}
            parameters.schedule_idx = this.join_schedule_idx;
            parameters.page = 1

            const res = await this.$Axios.get('/api/join/schedule/review/sent', {params: parameters})

            this.reviewList = res.data.soccerhows
        },
        async getReceivedReviewHistory(){
            const parameters = {}
            parameters.writer_idx = this.member_idx;
            parameters.page = 1

            const res = await this.$Axios.get('/api/join/schedule/review/taken', {params: parameters})

            this.reviewList = res.data.soccerhows
        },
        setPopup() {
            const isShowPopup = localStorage.getItem('isShowPopup')
            if (isShowPopup === null) {
                localStorage.setItem('isShowPopup', true)
            }
            this.isShowPopup = JSON.parse(isShowPopup)
        },
        hidePopup() {
            this.isShowPopup = false
            localStorage.setItem('isShowPopup', false)
        }
    },
    created() {
        if(this.reviewPageType === REVIEW_PAGE_TYPE.SENT){
            this.getSentReviewHistory()
            this.setPopup()
        }else if(this.reviewPageType === REVIEW_PAGE_TYPE.RECEVIED){
            this.getReceivedReviewHistory()
        }

    }
}
</script>

<style scoped>
.title {
    font-weight: 500; font-size: 12px; line-height: 24px; color: #606060; margin-bottom: 4px;
}
</style>